export default "__VITE_ASSET__CuIf6bEf__"